import { Box, Button, Typography } from '@mui/material';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { useNavigate } from 'react-router-dom';

export function NotFound() {
  const navigate = useNavigate();

  return (
    <Box minHeight={'calc(100vh - 48px)'} display={'flex'} alignItems={'center'} justifyContent={'center'} p={2}>
      <Box textAlign={'center'}>
        <Typography variant={'h4'} mb={1}>
          Page not found
        </Typography>
        <Typography color={'text.secondary'} mb={3}>
          The requested page does not exist or is not available for your account.
        </Typography>
        <Button variant={'contained'} startIcon={<HomeOutlinedIcon />} onClick={() => navigate('/')}>
          Dashboard
        </Button>
      </Box>
    </Box>
  );
}
